import { request } from 'Lib/axios'
import { useQuery } from '@tanstack/react-query'
import { ExtractFnReturnType, QueryConfig } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'

export type MigratedDomainMonitorMode = {
  address: string
  monitorMode: boolean
  paidMarketingConnected: boolean
}

export type GetDomainsResponse = {
  data: Array<MigratedDomainMonitorMode>
}

const getMigrationMonitorMode = async (accountId: number) =>
  await request<GetDomainsResponse>({
    url: `accounts-migration/${accountId}/monitor-mode`,
    method: 'GET',
  })

type QueryFnType = typeof getMigrationMonitorMode

export const useGetMigrationMonitorMode = (
  isMigratedAccount: boolean,
  config?: QueryConfig<QueryFnType>
) => {
  const { accountId } = useUserStore.getState()

  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['getMigrationMonitorMode', accountId],
    enabled: !!accountId && isMigratedAccount,
    queryFn: () => getMigrationMonitorMode(accountId),
    ...config,
  })

  const data = query.data && query.data instanceof Error ? undefined : query.data?.data || []

  return { ...query, data }
}
